/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateWorkPatternDto } from '../models/CreateWorkPatternDto';
import type { EmployeeWorkPatternDto } from '../models/EmployeeWorkPatternDto';
import type { WorkPatternDto } from '../models/WorkPatternDto';
import type { WorkPatternInput } from '../models/WorkPatternInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkPatternService {

  /**
   * @returns WorkPatternDto Success
   * @throws ApiError
   */
  public static getWorkPatterns(): CancelablePromise<Array<WorkPatternDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/work-patterns',
    });
  }

  /**
   * @param requestBody 
   * @returns CreateWorkPatternDto Created
   * @throws ApiError
   */
  public static postWorkPatterns(
requestBody?: WorkPatternInput,
): CancelablePromise<CreateWorkPatternDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/work-patterns',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param employeeIds 
   * @returns EmployeeWorkPatternDto Success
   * @throws ApiError
   */
  public static getWorkPatternsEmployees(
dateFrom: string,
dateTo: string,
employeeIds: Array<number>,
): CancelablePromise<Array<EmployeeWorkPatternDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/work-patterns/employees',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'EmployeeIds': employeeIds,
      },
    });
  }

}
